import React from 'react';

const Loader = () => {
    return (
        <div id="loader">
            <div className="spinner-grow text-secondary "></div>
        </div>
    )
}

export default Loader
